import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { Exporter, ExporterImporterCreate, Importer, Profile } from 'src/app/domain/models/Profile';

@Component({
  selector: 'app-admin-exporter-importers-page',
  templateUrl: './admin-exporter-importers-page.component.html',
  styleUrls: ['./admin-exporter-importers-page.component.css'],

})
export class AdminExporterImportersPageComponent implements OnInit {

  @Input() exporterProfile: Profile | undefined
  @Output() closeDialog = new EventEmitter();

  exporterId: number | undefined
  exporter: Exporter | undefined
  importers: Importer[] = []

  formGroup: FormGroup = this._formBuilder.group({
    exporterId: [{value: '', disabled: true}],
    profileType: [{value: '', disabled: true}],
    companyName: [{value: '', disabled: true}],
    vat: [{value: '', disabled: true}],
    contactName: [{value: '', disabled: true}],
    contactEmail: [{value: '', disabled: true}],
    contactCity: [{value: '', disabled: true}],
    country: [{value: '', disabled: true}],
    phone: [{value: '', disabled: true}]
  })

  loading: boolean = false

  constructor(
    private _messageService: MessageService,
    public translate: TranslateService,
    private _profileService: ProfileGateway,
    private readonly _formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    if (this.exporterProfile !== undefined) {
      this.exporterId = this.exporterProfile.id;
    }
    this.loadImporters()
  }

  loadImporters() {
    if(this.exporterId) {
      this.loading = true
      this._profileService.getAllImportersForExporterAsociation(this.exporterId).subscribe({
        next: (v) => {
          this.importers = v.importers
          this.exporter = v.exporter
          this.exporter.phone = this.exporterProfile?.contactPhone
          this.setForm()
          this.loading = false
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'No se pudieron recuperar los importers' })
        }
      })
    }
  }

  setForm() {
    this.formGroup.patchValue({
      exporterId: this.exporter?.id,
      profileType: this.translate.instant('AdminUsersManagement.CreateEditUser.ExporterLabel'),
      companyName: this.exporter?.companyName,
      vat: this.exporter?.vat,
      contactName: this.exporter?.contactName,
      contactEmail: this.exporter?.contactEmail,
      contactCity: this.exporter?.contactCity,
      country: this.exporter?.country,
      phone: this.exporter?.phone
    })
  }

  onToogleAsociation(importerId: number, event: any) {
    if(this.exporterId) {
      const request: ExporterImporterCreate = {
        exporterId: this.exporterId,
        importerId: importerId,
        isAsociated: event.checked
      }

      this.loading = true
      this._profileService.toogleExporterImporterAsociation(request).subscribe({
        next: (v) => {
          this.loading = false
          this.loadImporters()
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'No se pudo actualizar la asociación' })
        }
      })
    }
  }

  close(): void {
    this.closeDialog.emit()
  }
}
